import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Pipelines listing route (`/integrations/pipelines`). Super-admin only — a
 * cross-connection operational view of data pipelines. Lazy-loaded to keep it
 * off the initial authenticated bundle.
 */
const PipelinesPage = lazy(() => import('~/features/integrations/pages/pipelines-page'));

// Persist the page-local subsidiary scope in the URL (opaque `?sc=`).
const searchSchema = z.object({
  sc: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/_tenant/integrations/pipelines/')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <PipelinesPage />
    </Suspense>
  );
}
